'use client';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Toaster from '@/components/shared/Toaster/index';
import Typography from '@/components/shared/typography/typography.component';
import {
    useAppDispatch,
    useStepper,
    useTranslation,
    useWindowDimensions,
} from '@/hook';
import classes from './styles.module.scss';
import { X } from '../../../../../../public/Images';
import { useForm } from 'react-hook-form';
import { useNotifyMeMutation } from '@/hook/retail-api-slice';
import { setToaster } from '@/redux/reducers/checkoutReducer';
import Image from 'next/image';

import {
    useVerifyOtpMutation,
    useSendOtpMutation,
    useResendOtpMutation,
} from '@/hook/slices/otp-api-slice';
import OtpInput from 'react-otp-input';
import {
    mobileValidationPattern,
    validNumberRegex,
} from '@/constants/validations';
import myImageLoader from '@/image.local.loader';
import { WhatsappIcon } from 'public/Images';
const FirstScreen = ({
    setModal,
    nextStep,
    carId: vehicleId,
    clearForm = false,
}: {
    setModal: Dispatch<SetStateAction<boolean>>;
    nextStep: Dispatch<SetStateAction<number>>;

    carId: string;
    clearForm: boolean;
}) => {
    const { t } = useTranslation();
    const { translateNumbers } = useStepper();
    const dispatch = useAppDispatch();
    const { register, handleSubmit, watch, setValue } = useForm();
    const { name, phone } = watch();

    const [btnText, setBtnText] = useState(t('get OTP'));
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
    const [otpValues, setOtpValues] = useState<string>('');
    const [count, setCount] = useState(30);

    const { IS_DESKTOP } = useWindowDimensions();

    const [
        notifyMe,
        {
            isLoading: isLoadingNotifyMe,
            isSuccess: isSuccessNotifyMe,
            isError: isErrorNotifyMe,
        },
    ] = useNotifyMeMutation();
    const [
        sendOtp,
        { isLoading: isLoadingSendOtp, isSuccess: isSuccessSendOtp },
    ] = useSendOtpMutation();
    const [resendOtp] = useResendOtpMutation();
    const [
        verifyOtp,
        {
            isLoading: isLoadingVerifyOtp,
            isSuccess: isSuccessVerifyOtp,
            error: errorVerifyOtp,
        },
    ] = useVerifyOtpMutation();

    const onSumbit = (data: any) => {
        const formData = {
            phone: data.phone,
            name: data.name,
        };
        const applicationData = {
            ...formData,
            eventType: 'CAR_RESERVATION_RELEASED',
            vehicleId,
        };
        notifyMe(applicationData);
    };
    const handleBtnClicked = () => {
        if (btnText == t('get OTP')) {
            sendOtp(phone);
            setDisableSubmitBtn(true);
            return;
        }
        if (btnText == t('Notify Me')) {
            verifyOtp({ phone, otp: otpValues });
        }
    };
    const resendOtpClicked = e => {
        e.preventDefault();
        resendOtp({ phone, channel: 'sms' });
        setCount(30);
        setOtpValues('');
    };

    const resendOtpWhatsappClicked = e => {
        e.preventDefault();
        resendOtp({ phone, channel: 'whatsapp' });
        setCount(30);
        setOtpValues('');
    };

    const setToasterWrapper = ({ flag, message, type }) => {
        dispatch(
            setToaster({
                flag,
                message,
                type,
            })
        );
    };
    useEffect(() => {
        if (isSuccessSendOtp) {
            setShowOtpInput(true);
            setDisableSubmitBtn(false);
            setBtnText(t('Notify Me'));
        }
    }, [isSuccessSendOtp]);
    useEffect(() => {
        if (isLoadingSendOtp || isLoadingVerifyOtp || isLoadingNotifyMe) {
            setDisableSubmitBtn(true);
        }
    }, [isLoadingSendOtp, isLoadingVerifyOtp, isLoadingNotifyMe]);
    useEffect(() => {
        if (
            name &&
            phone &&
            mobileValidationPattern.test(phone) &&
            name.length > 0
        ) {
            if (disableSubmitBtn) setDisableSubmitBtn(false);
        } else {
            if (!disableSubmitBtn) {
                setDisableSubmitBtn(true);
                if (name !== '') {
                    setBtnText(t('get OTP'));
                }
                if (phone && !mobileValidationPattern.test(phone)) {
                    setShowOtpInput(false);
                    setOtpValues('');
                }
            }
        }
    }, [name, phone]);
    useEffect(() => {
        if (isSuccessSendOtp) {
            setShowOtpInput(true);
            setDisableSubmitBtn(false);
            setBtnText(t('Notify Me'));
            setCount(30);
        }
    }, [isSuccessSendOtp]);
    useEffect(() => {
        if (isSuccessNotifyMe) {
            nextStep(1);
        }
    }, [isSuccessNotifyMe]);

    useEffect(() => {
        if (isSuccessVerifyOtp) {
            handleSubmit(onSumbit)();
        }
    }, [isSuccessVerifyOtp]);

    useEffect(() => {
        if (isErrorNotifyMe) {
            setToasterWrapper({
                flag: true,
                message: t('something went wrong'),
                type: false,
            });
        }
    }, [isErrorNotifyMe]);
    useEffect(() => {
        if (errorVerifyOtp) {
            if ('data' in errorVerifyOtp && errorVerifyOtp.data) {
                const parsedErrorData = errorVerifyOtp.data as {
                    statusCode: number;
                };
                const { statusCode } = parsedErrorData;
                if (statusCode && statusCode === 422) {
                    setToasterWrapper({
                        flag: true,
                        message: t('loginOtpInvalidErrorMessage'),
                        type: false,
                    });
                }
            }
            setDisableSubmitBtn(false);
        }
    }, [errorVerifyOtp]);
    useEffect(() => {
        const interval = setInterval(() => {
            if (count > 0) {
                setCount(value => (value > 0 ? value - 1 : 0));
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        if (clearForm) {
            setValue('name', '');
            setValue('phone', '');
            setOtpValues('');
            setShowOtpInput(false);
            setBtnText(t('get OTP'));
        }
    }, [clearForm]);
    const bannedSymbols = ['.', '+', '-', ' '];
    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <div className={classes.textContainer}>
                    {IS_DESKTOP ? (
                        <Typography
                            variant="subtitle2Medium"
                            className={classes.title}
                        >
                            {t('Notify me when car is available')}
                        </Typography>
                    ) : null}
                    <Typography
                        variant="body2Medium"
                        className={classes.subtitle}
                    >
                        {t(
                            'Please fill your contact info. We’ll notify you if the reservation on this car is released'
                        )}
                    </Typography>
                </div>

                <Image
                    src={X.src}
                    width={X.width}
                    height={X.height}
                    alt="close"
                    className={classes.closeIcon}
                    onClick={() => setModal(false)}
                    style={{ cursor: 'pointer' }}
                />
            </div>

            <div className={classes.formContainer}>
                <Typography variant="body2Medium" className={classes.label}>
                    {t('name')}
                </Typography>
                <input
                    className={classes.input}
                    type="text"
                    placeholder={t('name')}
                    {...register('name')}
                />
                <Typography variant="body2Medium" className={classes.label}>
                    {t('Mobile Number')}
                </Typography>
                <input
                    className={classes.input}
                    type="number"
                    placeholder={'01xxxxxxxxx'}
                    step={1}
                    value={phone}
                    {...register('phone')}
                    onChange={e => {
                        let value = e.target.value;
                        value = value.trim();
                        if (
                            (validNumberRegex.test(value) || value === '') &&
                            value.length <= 11
                        ) {
                            setValue('phone', translateNumbers(value));
                        }
                    }}
                    onKeyDown={e => {
                        if (bannedSymbols.includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
                {showOtpInput && (
                    <div className={classes.otpContainer}>
                        <Typography
                            variant="body2Medium"
                            className={classes.label}
                        >
                            {t('OTP')}
                        </Typography>
                        <div dir="ltr">
                            <OtpInput
                                containerStyle={classes.otpInputsContainer}
                                renderInput={props => (
                                    <input
                                        {...props}
                                        className={classes.otpInput}
                                        maxLength={1}
                                        type="number"
                                    />
                                )}
                                numInputs={6}
                                value={otpValues}
                                onChange={setOtpValues}
                                shouldAutoFocus
                                inputType="number"
                            />
                        </div>
                        <Typography
                            variant="body2Medium"
                            className={classes.otpDisclaimer}
                        >
                            {t('OTPCodeValidFor')}
                        </Typography>
                        <div className={classes.otpModalContentResendContainer}>
                            <Typography variant={'body2'}>
                                {t('loginDidntGetMessage')}{' '}
                                {count !== 0 ? `(${count})` : ''}
                            </Typography>
                            <Typography
                                variant={'body2'}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}
                            >
                                {t('loginDidntGetMessageResend')}
                                <button
                                    className={classes.otpModalContentResend}
                                    onClick={e => {
                                        resendOtpClicked(e);
                                    }}
                                    disabled={count !== 0}
                                >
                                    {t('SMS')}
                                </button>
                                {t('or')}{' '}
                                <button
                                    className={classes.otpModalContentResend}
                                    onClick={e => {
                                        resendOtpWhatsappClicked(e);
                                    }}
                                    disabled={count !== 0}
                                >
                                    {t('Whatsapp')}{' '}
                                    <img
                                        src={myImageLoader({
                                            src: WhatsappIcon.src,
                                            width: 20,
                                            height: 20,
                                        })}
                                        alt={'Whatsapp Icon'}
                                    />
                                </button>
                            </Typography>
                        </div>
                    </div>
                )}
                <button
                    className={classes.btn}
                    disabled={disableSubmitBtn}
                    onClick={() => handleBtnClicked()}
                >
                    <Typography variant={'body1Medium'}>{btnText}</Typography>
                </button>
            </div>
            <Toaster />
        </div>
    );
};

export default FirstScreen;
